import React, {Fragment} from 'react';
import ReactNotification, { store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';

const withNotification = WrappedComponent => props => {

  const addNotification = (notificationType, notificationTitle, notificationMessage, notificationPosition) => {
		store.addNotification({
			title: notificationTitle,
			message: notificationMessage,
			type: notificationType,
			insert: "top",
			container: notificationPosition,
			animationIn: ["animated", "fadeIn"],
			animationOut: ["animated", "fadeOut"],
			dismiss: { duration: 2000 },
			dismissable: { click: true }
		});
	}

  return (
    <Fragment>
      <ReactNotification/>
      <WrappedComponent addNotification={addNotification} {...props} />
    </Fragment>
  )
};

export default withNotification;